import User from "./user";
import SiteData from "./site-data";
import Comment from "./comment";
var service = {
  User: User,
  SiteData: SiteData,
  Comment: Comment
};
export default service;